// keyboard keycode

export const Enter = {
  key: 'Enter',
  code: 13,
};

export const Esc = {
  key: 'Escape',
  code: 27,
};

export const Backspace = {
  key: 'Backspace',
  code: 8,
};

export const Tab = {
  key: 'Tab',
  code: 9,
};

export const Space = {
  key: '',
  code: 32,
};
export const ArrowUp = {
  key: 'ArrowUp',
  code: 38,
};

export const ArrowDown = {
  key: 'ArrowDown',
  code: 40,
};

export const ArrowLeft = {
  key: 'ArrowLeft',
  code: 37,
};

export const ArrowRight = {
  key: 'ArrowRight',
  code: 39,
};
